import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_FINANCING_LEDGER_REPORT } from "../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getFinancingLedgerReport =
  (requestData) => async (dispatch) => {
    dispatch(showLoading());
    await axios
      .post(`api/LendingReports/GetFinancingLedgerReport`, requestData)
      .then(({ data }) => {
        if (data) //debugger;
        dispatch({
          type: GET_FINANCING_LEDGER_REPORT,
          payload: data,
        });
        dispatch(hideLoading());
      })
      .catch(function (error) {
        dispatch(hideLoading());
        if (error.response) {
          if (error.response.status === 401) {
            logout();
            history.push("/login");
            history.go("/login");
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            );
          else {
            toast.error("Error while processing the request");
          }
        }
      });
  };

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetFinancingLedgerReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `GET_FINANCING_LEDGER_REPORT_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
                ws[address].v == "vizId"
                ? "VIZ ID"
                 : ws[address].v == "financier"
                ? "Financier"
                : ws[address].v == "distributorName"
                ? "Distributor"
                : ws[address].v == "distCenterName"
                ? "Dist Center"
                 : ws[address].v == "date"
                ? "Date"
                : ws[address].v == "shopCode"
                ? "Shop Code"
                : ws[address].v == "shopName"
                ? "Shop Name"
                : ws[address].v == "financierId"
                ? "Financier Id"
                 : ws[address].v == "invoiceNo"
                ? "Invoice No"
                : ws[address].v == "dlmTillName"
                ? "DLM Name"
                : ws[address].v == "dlmTillNo"
                ? "DLM Till No"
                : ws[address].v == "narration"
                ? "Narration"
                : ws[address].v == "debit"
                ? "Debit"
                : ws[address].v == "credit"
                ? "Credit"
                : ws[address].v == "balance"
                ? "Balance"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.report, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
